<template>
    <div>
        <div class="modal-overlay active"  @click="closeDialog()"></div>
        <div class="modal">
            <div class="modal__header">
                <h2 class="headline-s">California Prop 65 Warning</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="flex-column" v-if="itemInView">
                <a class="modal__goback" @click="viewProp65Description(null)">Go Back</a>
                <p style="text-decoration: underline;">
                    {{ itemInView.variation.rothcoItem?.rothco_item_no }} : {{ itemInView.variation.item?.name }}
                </p>
                <ul v-for="(spec) of itemInView.prop_65_specs" :key="spec.value.spev_value_id">
                    <li class="modal__body--content-wrapper">
                        <p><strong>WARNING:</strong> This product can expose you to <strong>{{ spec.value.spec_value }}</strong> which is known to the State of California to cause cancer and birth defects or other reproductive harm.</p>
                    </li>
                </ul>
            </div>
            <div class="modal__body" v-else>
                <WarningIcon class="modal__icon" width="32" alt="Warning" style="flex-shrink: 0;"/>
                <div class="flex-column">
                    <p class="warning-text"><strong>WARNING:</strong>The following item(s) in this cart can expose you to chemicals known to the State of California to cause cancer, birth defects and other reproductive harm (which was noted in the product description of the item). In order to sell in or ship this item into the state of California, items that fall under this classification must have proper labeling on the product and web listing or product offering.
                        <a href="https://www.p65warnings.ca.gov/" target="_blank" rel="noopener noreferrer">Click here to learn more about California Prop 65</a>.
                    </p>
                    <p class="warning-text">Please note that orders shipping to California may not ship the same day due to these labeling requirements.</p>
                    <p class="warning-text">You may click on each item below to see item specific chemical warnings:</p>
                    <a v-for="(prop65item) of prop65Items" :key="prop65item.list_item_id" @click.prevent="viewProp65Description(prop65item)">
                        {{ prop65item.variation.rothcoItem?.rothco_item_no }} : {{ prop65item.variation.item?.name }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

    import { ref, inject, computed } from "vue";
    const dialogRef = inject('dialogRef');
    import CloseIcon from "@icons/closeIcon.svg";
    import WarningIcon from "@icons/warning-icon.svg";
    const prop65Items = dialogRef?.value?.data?.prop65Items ?? [];

    const itemInView = ref(null);
    
    const viewProp65Description = (item)=>{
        itemInView.value = item
    }

    const closeDialog = () => {
        dialogRef?.value?.close();
    }
</script>
<style scoped lang="scss">
    .warning-text {
        padding-bottom: 1rem;
    }
</style>